<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="getData"
    ></SiruiSearch>
    <div class="main-content">
      <div class="btn-item-detail">
        <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
      </div>
      <div class="public-table">
        <vxe-grid
          ref="creditRating"
          border
          resizable
          show-overflow
          size="mini"
          height="500"
          :show-footer="true"
          :footer-method="footerMethod"
          :data="tableData.map((el) => ({ ...el, weightedScore: (el.score * el.weight) / 100 }))"
          :edit-rules="editRules"
          :edit-config="editConfig"
        >
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column field="firstIndexName" title="一级指标"></vxe-table-column>
          <vxe-table-column field="secondIndexName" title="二级指标"></vxe-table-column>
          <vxe-table-column field="thirdIndexName" title="三级指标"></vxe-table-column>
          <vxe-table-column field="weight" title="权重">
            <template #default="{ row }">
              {{ row.weight + '%' }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="score"
            title="单项得分"
            :edit-render="{ autofocus: '.el-input__inner' }"
          >
            <template v-slot:edit="{ row }">
              <el-input
                type="number"
                ref="score"
                v-model="row.score"
                step="1"
                @input="scoreChange(row)"
                oninput="if(value.length>10)value=value.slice(0,10)"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="weightedScore" title="单项加权得分"></vxe-table-column>
          <vxe-table-column field="rate" title="评级"></vxe-table-column>
        </vxe-grid>
      </div>
    </div>
  </div>
</template>

<script>
  import { getUserCompanyList } from '@/common/js/util';
  import SiruiSearch from '@/components/SiruiSearch';
  import buttonItem from '@/components/ButtonItem';
  import { mapState } from 'vuex';
  export default {
    name: 'creditRating',
    components: {
      SiruiSearch,
      buttonItem,
    },
    async mounted() {
      //获取默认公司
      this.query.companyCode = this.userInfo.companyCode;
      let res = await this.$axios.post('/maindata/partners/getPartnerExtendByPage', {
        pageNum: 1,
        pageSize: 10,
        partnerTypes: 'HZHB01,HZHB02',
      });
      this.query.partnerCode = res.data.data.list;
      this.allPartnerCodes = res.data.data.list;
      this.searchColumns[1].currentValue = res.data.data.list[0].partnerZhName || '';
      this.getButtonList();
      this.getData();
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            type: 'select', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'companyCode',
            changeMethod: 'searchCompanyChange',
            options: getUserCompanyList(),
          },
          {
            type: 'searchTableSpec',
            name: this.$t('salePurchase.search.supplierNo'),
            prop: 'partnerCode',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB01,HZHB02',
              // departmentCode: this.query.contractBusinessDepartment,//部门
              companyCode: this.query.contractBusinessCompanyNo, //公司
            },
            isMultiple: true,
            currentValue: '',
            isNeedMultipleValue: false,
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
        editRules: {
          score: [
            // { validator: nameValid },
            { type: 'number', required: true, min: 0, max: 100, message: '请输入0至100' },
          ],
        },
        menuButtonList: [],
        query: {
          companyCode: '',
          partnerCode: '',
        },
        departmentList: [],
        editConfig: {},
        level: '',
        allPartnerCodes: [],
      };
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      resetBtnClick() {
        this.query.companyCode = this.userInfo.companyCode;
        this.query.partnerCode = this.allPartnerCodes;
        this.getData();
      },
      getData() {
        this.getLevel();
        this.loading = true;
        this.editConfig = {};
        console.log(this.query);
        this.$axios
          .post('/sales/creditLimitEngineGrade/list', {
            ...this.query,
            partnerCode: this.query.partnerCode && this.query.partnerCode[0].partnerCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.tableData = res.data.data;
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      getLevel() {
        this.loading = true;
        this.$axios
          .post('/sales/creditLimitEngineGrade/getLevel', {
            ...this.query,
            partnerCode: this.query.partnerCode && this.query.partnerCode[0].partnerCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.level = res.data.data;
              this.loading = false;
            } else {
              this.level = '';
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      clickEvent(type) {
        if (type === 'edit') {
          this.edit();
        } else if (type === 'save') {
          this.save();
        }
      },
      edit() {
        this.getLevel();
        this.editConfig = { trigger: 'click', mode: 'row' };
        console.log(this.$refs);
        // this.$refs.score.focus()
        this.loading = true;
        //获取最新数据
        this.$axios
          .post('/sales/creditLimitEngineGrade/listNew', {
            ...this.query,
            partnerCode: this.query.partnerCode && this.query.partnerCode[0].partnerCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.tableData = res.data.data;
              this.$nextTick(() => {
                this.$refs.creditRating.setActiveRow(
                  this.$refs.creditRating.getTableData().fullData[0]
                );
              });
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      save() {
        this.$refs.creditRating.validate((errMap) => {
          if (errMap) {
            let params = this.$refs.creditRating.getTableData().fullData;
            // params.forEach(item => {
            //   if(!item.firstIndexName) {
            //     this.indexList.forEach(item2 => {
            //       if(item2.value === item.firstIndexCode) {
            //         item.firstIndexName = item2.label
            //       }
            //     })
            //   }
            // })
            this.$axios.post('/sales/creditLimitEngineGrade/save', params).then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: '保存成功',
                  type: 'success',
                });
                this.getData();
              } else {
                this.$alert(res.data.msg);
              }
            });
          }
        });
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            } else if (column.property === 'weight') {
              let total = 0;
              data.forEach((item) => {
                total += Number(item.weight);
              });
              return total + '%';
            } else if (column.property === 'weightedScore') {
              let total = 0;
              data.forEach((item) => {
                total += Number(item.weightedScore);
              });
              return total.toFixed(2);
            } else if (column.property === 'rate') {
              return this.level;
            }
          }),
        ];
      },
      scoreChange(row) {
        this.$refs.creditRating.validate(row, (errMap) => {
          if (errMap) {
            row.weightedScore = (row.score * row.weight) / 100;
            this.$refs.creditRating.updateFooter();
          } else {
            row.weightedScore = '';
          }
        });
      },
    },
  };
</script>

<style scoped></style>
